import React from 'react';

import {AlgoliaHitMappedType} from 'desktop/pages/success/types/orderItemsTypes';

import s from './suggestion.scss';

export type PropsType = AlgoliaHitMappedType;

/**
 * Component for render dr details options in autocomplete component
 * @param {PropsType} props - props type
 * @returns {React.ReactElement} Rendered react component
 */
export const Suggestion: React.FC<PropsType> = ({
    firstName,
    lastName,
    mailingAddress1stLine,
    mailingAddressCity,
    mailingAddressState,
    organizationName,
}) => {
    const nameString = `${firstName} ${lastName}`;
    const detailsString = `${mailingAddress1stLine}, ${mailingAddressCity}, ${mailingAddressState}`;
    return (
        <div className={s.suggestion}>
            <p className={s.name}>{nameString}</p>
            <p className={s.address}>{detailsString}</p>
            {organizationName && <p className={s.address}>{organizationName}</p>}
        </div>
    );
};

/**
 * Component for render selected dr details in autocomplete component
 * @param {AlgoliaHitMappedType[]} suggestions - all founded hits
 * @param {string | null} selectedSuggestionId - id of selected hit
 * @returns {React.ReactElement} Rendered react component
 */
export const SelectedComponent = (
    suggestions?: AlgoliaHitMappedType[],
    selectedSuggestionId?: string | null,
) => {
    if (!suggestions) return null;
    const foundedSuggestion = suggestions.find(item => item.id === selectedSuggestionId);
    if (!foundedSuggestion) return null;
    const {
        firstName,
        lastName,
        mailingAddress1stLine,
        mailingAddressCity,
        mailingAddressState,
        organizationName,
    } = foundedSuggestion;
    return (
        <div className={s.suggestion}>
            <p className={s.name}>
                {firstName} {lastName}
            </p>
            <p className={s.address}>
                {mailingAddress1stLine}, {mailingAddressCity}, {mailingAddressState}
            </p>
            {organizationName && <p className={s.address}>{organizationName}</p>}
        </div>
    );
};

/**
 * Component for render no result dr details in autocomplete component
 * @param {AlgoliaHitMappedType[]} suggestions - all founded hits
 * @param {string | null} selectedSuggestionId - id of selected hit
 * @returns {React.ReactElement} Rendered react component
 */
export const NoResultComponent = ({onClick}: {onClick: React.MouseEventHandler<HTMLElement>}) => (
    <button className={s.noResultWrapper} onClick={onClick} type="button">
        <p className={s.noResultDescription}>No results found.</p>
        <p className={s.noResultAction}>Manually add doctor or clinic name</p>
    </button>
);
